
import React from "react";
import TVScreenFrame from "./TVScreenFrame";

function ImageOnScreen({
  image,
  background = "/assets/walkthrough/bg_room.png",
}) {
  return (
    <TVScreenFrame background={background}>
      <img
        src={image}
        alt="Screen"
        style={{
          width: "97%",
          height: "93%",
          objectFit: "contain",
          borderRadius: "8px",
          background: "#000",
          boxShadow: "0 2px 12px 2px rgba(0,0,0,0.45)",
        }}
      />
    </TVScreenFrame>
  );
}

export default ImageOnScreen;
